import React, { Component } from 'react'
import '../styles/ClusterCommitments.css'
import AlertMessage from '../widgets/AlertMessage'
import ActivityIndicator from '../widgets/ActivityIndicator'
import OrgFooter from '../widgets/OrgFooter'
import APIClusterRequest from '../api/APIClusterRequest'
import APISupplyPlanRequest from '../api/APISupplyPlanRequest'

class ClusterCommitments extends Component
{
	constructor(props) {
		super(props)
		this.state = {
			accessToken: JSON.parse(sessionStorage.getItem("token")),
			user: JSON.parse(sessionStorage.getItem("user")),
			clusterId: props.clusterId,
			targetCropId: props.targetCropId,
			spid: props.spid,
			ciid: props.ciid,
			listItems: [],
			farmers: {},
			clusterMembers: {}
		}
		this.setTableValues = this.setTableValues.bind(this)
		this.handleFooterEvent = this.handleFooterEvent.bind(this)
		this.onSubmit = this.onSubmit.bind(this)
		this.itemEventHandler = this.itemEventHandler.bind(this)
		this.getAllFarmerCommitmentsBySupplyId = this.getAllFarmerCommitmentsBySupplyId.bind(this)
		this.addFarmerCommitmentsByClusterInvolvementId = this.addFarmerCommitmentsByClusterInvolvementId.bind(this)
		this.editFarmerCommitmentsByClusterInvolvementId = this.editFarmerCommitmentsByClusterInvolvementId.bind(this)
		this.getFarmerCommitmentsByClusterInvolvementId = this.getFarmerCommitmentsByClusterInvolvementId.bind(this)
		this.editSupplyPlan = this.editSupplyPlan.bind(this)
	}

	onSubmit() {
		const clusterMembers = []
		const addClusterMembers = []
		Object.values(this.state.clusterMembers).forEach((v => {
			if(v.commitment_id == null) {
				addClusterMembers.push(v)
			}
			else {
				clusterMembers.push(v)
			}
		}))
		const data = {}
		if(clusterMembers.length > 0) {
			data["farmerCommitment"] = clusterMembers
			if(addClusterMembers.length > 0) {
				data["add"] = {}
				data["add"]["farmerCommitment"] = addClusterMembers
			}
			this.editFarmerCommitmentsByClusterInvolvementId(data)
		}
		else {
			data["farmerCommitment"] = addClusterMembers
			this.addFarmerCommitmentsByClusterInvolvementId(data)
		}
	}

	addFarmerCommitmentsByClusterInvolvementId(data) {
		const apiReq = APISupplyPlanRequest.addFarmerCommitmentsByClusterInvolvementId(this.state.accessToken, data, this.state.ciid)
		apiReq.then((response) => {
			if(response.status !== "SUCCESS") {
				this.setState({
					showWarningMessage: true,
					aMessage: response.status + "! " + response.description,
					showActivityIndicator: false
				})
				return
			}
			this.getFarmerCommitmentsByClusterInvolvementId((members) => {
				this.getClusterById(members)
			})
			this.setState({
				showInfoMessage: true,
				aMessage: response.status + "! " + response.description,
				showActivityIndicator: false
			})
		})
	}

	editFarmerCommitmentsByClusterInvolvementId(data) {
		const apiReq = APISupplyPlanRequest.editFarmerCommitmentsByClusterInvolvementId(this.state.accessToken, data, this.state.ciid)
		apiReq.then((response) => {
			if(response.status !== "SUCCESS") {
				this.setState({
					showWarningMessage: true,
					aMessage: response.status + "! " + response.description,
					showActivityIndicator: false
				})
				return
			}
			this.getFarmerCommitmentsByClusterInvolvementId((members) => {
				this.getClusterById(members)
			})
			this.setState({
				showInfoMessage: true,
				aMessage: response.status + "! " + response.description,
				showActivityIndicator: false
			})
		})
	}

	editSupplyPlan(targetVolume) {
		const data = {
			supplyPlan: {
				"target_volume": targetVolume
			}
		}
		const apiReq = APISupplyPlanRequest.editSupplyPlanById(this.state.accessToken, data, this.state.spid)
		apiReq.then((response) => {
			console.log('editSupplyPlanById ', response)
		})
	}

	componentWillMount() {
		this.getFarmerCommitmentsByClusterInvolvementId((members) => {
			this.getClusterById(members)
		})
		if(this.props.data) {
			this.setState({deliveryDate: this.props.data})
		}
	}

	getAllFarmerCommitmentsBySupplyId(members) {
		const apiReq = APISupplyPlanRequest.getAllFarmerCommitmentsBySupplyId(this.state.accessToken, this.state.spid)
		apiReq.then((response) => {
			if(response.status !== "SUCCESS") {
				this.setState({
					showWarningMessage: true,
					aMessage: response.status + "! " + response.description,
					showActivityIndicator: false
				})
				return
			}
			for(const v of response.results.farmerCommitment) {
				if(members[v.farmer_id] != null) {
					members[v.farmer_id]["commitment_id"] = v.commitment_id
					members[v.farmer_id]["supply_commitment"] = v.supply_commitment
					members[v.farmer_id]["evaluated_supply"] = v.evaluated_supply
				}
			}
			this.setTableValues(Object.values(members))
		})
	}

	getClusterById(members) {
		this.setState({showActivityIndicator: true})
		const cluster = APIClusterRequest.getClusterById(this.state.accessToken, this.state.clusterId)
		cluster.then((response) => {
			if(response.status === "FAILED") {
				this.setState({showActivityIndicator: false})
				return
			}
			if(response.status === "ERROR") {
				this.setState({
					showWarningMessage: true,
					aMessage: response.status + "! " + response.description,
					showActivityIndicator: false
				})
				return
			}
			const keys = Object.keys(members)
			const m = []
			response.results.members.map((item, i) => {
				if(keys.includes(item.farmer_id.toString())) {
					m.push(members[item.farmer_id.toString()])
				}
				else {
					m.push(item)
				}
			})
			this.setTableValues(m)
			this.setState({
				members: response.results.members,
				showActivityIndicator: false
			})
		})
	}

	getFarmerCommitmentsByClusterInvolvementId(callback) {
		this.setState({showActivityIndicator: true})
		const apiReq = APISupplyPlanRequest.getFarmerCommitmentsByClusterInvolvementId(this.state.accessToken, this.state.ciid)
		apiReq.then((response) => {
			if(response.status === "FAILED") {
				this.setState({showActivityIndicator: false})
				return
			}
			if(response.status === "ERROR") {
				this.setState({
					showWarningMessage: true,
					aMessage: response.status + "! " + response.description,
					showActivityIndicator: false
				})
				return
			}
			const m = {}
			let evalSupply = 0
			for(const v of response.results.farmerCommitment) {
				m[v.farmer_id] = v
				evalSupply += v.evaluated_supply
			}
			this.editSupplyPlan(evalSupply)
			callback(m)
		})
	}

	setTableValues(members) {
		members.sort((a, b) => {
			return(a.first_name.localeCompare(b.first_name))
		})
		const listItems = []
		for(const m of members) {
			listItems.push(<ListItem data={m} handler={this.itemEventHandler} dDate={this.state.deliveryDate}
				spid={this.state.spid} disabled={this.state.disabled} key={Math.random()} />)
		}
		this.setState({listItems: listItems})
	}

	itemEventHandler(from, farmerId, value) {
		this.state.clusterMembers[farmerId] = value
	}

	handleFooterEvent(e) {
		this.props.setView("update", this.state.clusterId, null, this.state.spid)
	}

	render() {
		const view = <div className="cluster-commitments">
			<div id="cc-scroll-area"><div id="cc-client-area">
			<div id="cc-table">
					<div className="cc-reg-no">Farmer Registration Number</div>
					<div className="cc-name">Cluster Member Name</div>
					<div className="cc-step2-area">Commited Delivery Date</div>
					<div className="cc-step4">STEP 4: Commitment Volume</div>
					<div className="cc-step6">STEP 6: Final Commited Volume</div>
					<div className="cc-step4">Remarks/Notes</div>
				</div>
				{this.state.listItems}
			</div>
			</div>
			<div className="alternate-footer">
				<OrgFooter submit={this.onSubmit} eventHandler={this.handleFooterEvent}
					showClose={!this.state.disabled}
					showSubmit={(this.state.user.role_id == 3)? !this.state.disabled: false}
					showUpdate={this.state.disabled}/>
			</div>
			{this.state.showInfoMessage == true && <AlertMessage type="information" text={this.state.aMessage}
				onClick={() => {
					this.setState({showInfoMessage: false})
					this.handleFooterEvent()
				}} />}
			{this.state.showWarningMessage == true && <AlertMessage type="warning" text={this.state.aMessage}
				onClick={() => { this.setState({showWarningMessage: false}) }} />}
			{this.state.showActivityIndicator && <ActivityIndicator showActivityIndicator={this.state.showActivityIndicator} />}
		</div>
		return(view)
	}
}

class ListItem extends Component
{
	constructor(props) {
		super(props)
		this.state = {
			isOn: false,
			areaPlanted: "0.0",
			initialCommitment: "0.0",
			member: {},
			spid: props.spid
		}
	}

	componentWillMount() {
		if(this.props.data != null) {
			let mi = ''
			if(this.props.data.middle_name != null) {
				mi = this.props.data.middle_name.charAt(0) + "."
			}
			const extn = (this.props.data.extension_name != null)? this.props.data.extension_name: ""
			const name = this.props.data.first_name + " " + mi + " " + this.props.data.last_name + " " + extn
			this.state.member["farmer_id"] = this.props.data.farmer_id
			this.state.member["commitment_id"] = this.props.data.commitment_id
			let supplyCommitment = (this.props.data.supply_commitment == null)? null: `${this.props.data.supply_commitment}`.replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")
			let evaluatedSupply = (this.props.data.evaluated_supply == null)? null: `${this.props.data.evaluated_supply}`.replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")
			let isEvaluatedSupplyZero = false
			if(evaluatedSupply == null || evaluatedSupply == 0) {
				evaluatedSupply = supplyCommitment
				isEvaluatedSupplyZero = true
			}
			this.setState({
				regNum: this.props.data.registration_no,
				name: name.toUpperCase(),
				farmerId: this.props.data.farmer_id,
				areaPlanted: (this.props.data.area_planted == null)? "0.0": this.props.data.area_planted,
				initialCommitment: (this.props.data.initial_commitment == null)? "0": this.props.data.initial_commitment,
				supplyCommitment: supplyCommitment,
				evaluatedSupply: evaluatedSupply,
				isEvaluatedSupplyZero: isEvaluatedSupplyZero,
				remarks: this.props.data.remarks
			})
		}
	}

	render() {
		const view = <div className="cc-listItem">
			<div className="cc-reg-no li-reg-no" disabled={this.state.disabled}>{this.state.regNum}</div>
			<div className="cc-name li-name" disabled={this.state.disabled}>{this.state.name}</div>
			<div className="cc-step2-area li-step2-area">
				<input type="text" value={formatDate(this.props.dDate)} disabled={true} />
			</div>
			<div className="cc-step4 li-step4">
				<input type="text" value={this.state.supplyCommitment} placeholder='0' onChange={(e) => {
					const value = e.target.value.replace(/,/g, "")
					const checker = /^[0-9]+$/;
					const isValid = checker.test(value);
					if(isValid) {
						this.state.member["supply_commitment"] = value
						if(this.state.isEvaluatedSupplyZero) {
							this.state.member["evaluated_supply"] = value
						}
						this.props.handler("step-4", this.state.farmerId, this.state.member)
						const nm = (e.target.value >= this.state.evaluatedSupply)? true: false
						this.setState({
							notMet: nm,
							supplyCommitment: value.replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")
						})
					}
					else {
						if(isNaN(parseInt(e.target.value))) {
							this.setState({supplyCommitment: null})
							e.target.value = "";
						}
						else {
							e.target.value = parseInt(e.target.value);
						}
					}
				}} disabled={this.state.disabled} />
			</div>
			<div className="cc-step6 li-step6">
				<input type="text" value={this.state.evaluatedSupply} placeholder='0' onChange={(e) => {
					const checker = /^[0-9]+$/;
					const isValid = checker.test(e.target.value);
					if(isValid) {
						this.state.member["evaluated_supply"] = e.target.value
						this.props.handler("step-6", this.state.farmerId, this.state.member)
						const nm = (this.state.supplyCommitment >= e.target.value)? true: false
						this.setState({notMet: nm, evaluatedSupply: e.target.value})
					}
					else {
						if(isNaN(parseInt(e.target.value))) {
							this.setState({evaluatedSupply: null})
							e.target.value = "";
						}
						else {
							e.target.value = parseInt(e.target.value);
						}
					}
				}} disabled={this.state.disabled} />
			</div>
			<div className="cc-step4 li-step2-remarks">
				<input type="text" value={this.state.remarks} onChange={(e) => {
					this.state.member["remarks"] = e.target.value
					this.props.handler("remark", this.state.farmerId, this.state.member)
					this.setState({remarks: e.target.value})
				}} />
			</div>
		</div>
		return(view)
	}
}

const formatDate = (value) => {
	const dt = new Date(value)
	const d = (dt.getDate().toString().length == 1)? `0${dt.getDate()}`: dt.getDate()
	const m = (`${dt.getMonth()+1}`.length == 1)? `0${dt.getMonth()+1}`: dt.getMonth()+1
	const dFormat = `${m} / ${d} / ${dt.getFullYear()}`
	return(dFormat)
}

export default ClusterCommitments
